module.exports = __webpack_public_path__ + "img/creditcard.a629f42a.svg";